import { Button, Dropdown, Row, Col } from 'react-bootstrap';
import React, { useState } from 'react';
import { FaEllipsisV, FaMoneyBillWave } from 'react-icons/fa';

import { Checkbox } from '@mui/material';
import { IoStar } from 'react-icons/io5';
import { numberFormatter } from '../../../../../utils/helpers/numberFormater';
import { IBookCardProps } from './BookingContractsCardItem';
import { useTranslation } from 'react-i18next';
import { CustomImageHandler } from '../../../../../shared/components/CustomImageHandler';
import {
    clearHtmlFromString,
    formatDate,
    getNumberPosts,
    getSocialIcons,
} from '../../../../../shared/functions/Functions';
import { priceSplitter } from '../../../../../utils/helpers/priceSplitter';
import { BookingAcceptContractModal } from './BookingAcceptContractModal';
import { DeclineOfferModal } from '../../../../influencer/offer/modal/offer-modal/components/DeclineOfferModal';
import { ConfirmSendingOfferModal } from '../../../../influencer/offer/modal/offer-modal/components/ConfirmSendingOfferModal';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../store/rootReducer';
import { BookingContractModal } from './modal/BookingContractModal';
import { IContract } from '../../../../../model/shared/IContract';
import { ConfirmationModal } from '../../../../../shared/components/modal/ConfirmationModal';
import TooltipOverlay from '../../../../../shared/components/tooltip/Tooltip';
import { CheckModalIcon, CrossModalIcon, DeleteIcon, EditIcon } from '../../../../../shared/Icons';

export function BookingContractsListItem({
    contracts,
    acceptContract,
    declineContract,
    approveProposal,
    declineProposal,
    deleteProposal,
    selectContract,
    setUpdateContracts,
    setBestPickAction,
    setDeclineReason,
}: IBookCardProps) {
    const { t } = useTranslation();
    const {
        user: { isSupervisor, isClient },
    } = useSelector((state: IAllStates) => state.auth);
    const [showBookingModal, setShowBookingModal] = useState(false);
    const [contractId, setContractId] = useState(0);
    const [userId, setUserId] = useState(0);
    const [contractModalStatus, setContractModalStatus] = useState('');
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showDeclineModal, setShowDeclineModal] = useState(false);
    const [isProposalDecline, setIsProposalDecline] = useState(false);
    const [showDeleteProposalModal, setShowDeleteProposalModal] = useState(false);
    const [contractData, setContractData] = useState<IContract>();
    const [approveTarget, setApproveTarget] = useState<IContract>();
    const whoImpersonate = localStorage.getItem('whoImpersonate');
    const canSelectBestPick = whoImpersonate || isSupervisor;
    const pendingAndNegotiateStatus = ['pending', 'negotiate'];

    const openModal = (id: number, user: number, negotiateStatus = false) => {
        setContractId(id);
        setUserId(user);
        setShowBookingModal(true);
        if (negotiateStatus) {
            setContractModalStatus('negotiate');
        }
    };

    const opeDeclineModal = (id: number, contract: IContract) => {
        setShowDeclineModal(true);
        setIsProposalDecline(false);
        setContractId(id);
        setContractData(contract);
    };

    const opeProposalDeclineModal = (id: number, contract: IContract) => {
        setShowDeclineModal(true);
        setIsProposalDecline(true);
        setContractId(id);
        setContractData(contract);
    };

    const openConfirmModal = (id: number, contract: IContract) => {
        setShowConfirmModal(true);
        setContractId(id);
        setContractData(contract);
    };

    const closeModal = () => {
        setShowBookingModal(false);
        setContractModalStatus('');
    };

    const closeConfirmModal = () => {
        setShowConfirmModal(false);
    };

    const declineOfferAction = () => {
        if (isProposalDecline) {
            if (declineProposal) {
                declineProposal(contractId ?? 0);
            }
        } else if (declineContract) {
            declineContract(contractId ?? 0);
        }
        setShowDeclineModal(false);
    };

    const approveProposalAction = (id: number) => {
        if (approveProposal) {
            approveProposal(id);
        }
    };

    const openDeleteProposalModal = (id: number) => {
        setShowDeleteProposalModal(true);
        setContractId(id);
    };

    const deleteProposalAction = () => {
        if (deleteProposal) {
            deleteProposal(contractId ?? 0);
        }
    };

    const acceptOfferConfirmModal = () => {
        acceptContract(contractId);
    };
    return (
        <div className="col">
            <BookingContractModal
                show={showBookingModal}
                closeModal={closeModal}
                contractId={contractId}
                modalStatus={contractModalStatus}
                userId={userId}
                acceptContract={acceptContract}
                declineContract={declineContract}
                approveProposal={approveProposal}
                declineProposal={declineProposal}
                deleteProposal={deleteProposal}
                selectContract={selectContract}
                setUpdateList={setUpdateContracts}
                setDeclineReason={setDeclineReason}
            />

            <BookingAcceptContractModal
                action={acceptOfferConfirmModal}
                show={showConfirmModal}
                closeModal={closeConfirmModal}
                user={contractData?.user}
                grandTotal={priceSplitter(contractData?.price)}
                nbPosts={getNumberPosts(contractData?.totalPlatforms)}
            />
            <DeclineOfferModal
                date={formatDate(contractData?.createdAt ?? '')}
                declineOffer={declineOfferAction}
                show={showDeclineModal}
                closeModal={() => setShowDeclineModal(false)}
                setDeclineReason={setDeclineReason}
                isContract={true}
            />
            <ConfirmSendingOfferModal
                action={() => approveProposalAction(approveTarget?.id ?? 0)}
                grandTotal={priceSplitter(approveTarget?.price)}
                show={!!approveTarget}
                disableButton={false}
                closeModal={() => setApproveTarget(undefined)}
                nbPosts={getNumberPosts(approveTarget?.totalPlatforms)}
                user={approveTarget?.user}
                isContract={true}
                isProposalApproval={true}
            />
            <ConfirmationModal
                show={showDeleteProposalModal}
                closeModal={() => setShowDeleteProposalModal(false)}
                action={deleteProposalAction}
                title={t('brand.campaign.book.offer.delete_proposal')}
                description={t('brand.campaign.book.offer.delete_proposal_confirm')}
            />

            {contracts?.map(contract => {
                const proposalStatusClass = contract?.isApproved
                    ? 'proposal-approved'
                    : contract?.isDeclined
                    ? 'proposal-declined'
                    : 'primary';
                const proposalStatusText = contract?.isApproved
                    ? t('brand.campaign.book.offer.approved')
                    : contract?.isDeclined
                    ? t('brand.campaign.book.offer.declined')
                    : t('general.campaign_status.proposed');
                return (
                    <Row
                        key={`${contract?.id}-list-item`}
                        className={`booking-list-card border-${contract.status} ${
                            contract?.isProposed ? 'border-proposed' : ''
                        } align-items-center position-relative`}
                    >
                        {contract?.isProposed && contract?.isConvertedToOffer && (
                            <div>
                                <span className="position-absolute d-flex" style={{ top: 10, right: 10, zIndex: 2 }}>
                                    <TooltipOverlay content={t('brand.campaign.book.offer.offer_sent_tooltip')}>
                                        <img src="/icons/approved-icon.svg" alt="Offer sent" />
                                    </TooltipOverlay>
                                </span>
                            </div>
                        )}
                        <Col
                            className="col-md-auto col-12 max-h-180px position-relative cursor-pointer overflow-hidden px-0"
                            onClick={() => openModal(contract?.id, contract?.user?.id)}
                        >
                            <CustomImageHandler
                                altTag={contract?.user?.profilePhoto?.name ?? ''}
                                classes="booking-list-image "
                                photoPath={contract?.user?.profilePhoto?.path ?? ''}
                                thumbnailPath={contract?.user?.profilePhoto?.path}
                                name={contract?.user?.displayName}
                            />
                        </Col>
                        <div
                            className="py-3 row px-0 px-md-3 flex-wrap align-items-center justify-content-between col"
                            style={{ gap: 18 }}
                        >
                            <div className="col" onClick={() => openModal(contract?.id, contract?.user?.id)}>
                                <h5>{contract?.user?.displayName}</h5>
                                <span className="text-muted">{contract?.user?.displayName}</span>
                                <div className={`rating mt-1 ${contract?.user?.totalRating === 0 && 'd-none'}`}>
                                    {contract?.user?.totalRating?.toFixed(2) ?? 0}
                                    <IoStar className="text-primary" />
                                </div>
                            </div>

                            <Col
                                className="d-flex align-items-center cursor-pointer"
                                style={{ gap: 12 }}
                                onClick={() => setContractId(contract.id)}
                            >
                                {contract?.totalPlatforms?.map((platform: any) => (
                                    <>
                                        {getSocialIcons({
                                            iconPath: platform.path,
                                            dataTop: `x${platform.nbPostsTotal}`,
                                            dataDown: numberFormatter(platform.followers),
                                            colorText: 'primary',
                                            parentClasses: 'w-100',
                                        })}
                                    </>
                                ))}
                            </Col>
                            <Col onClick={() => openModal(contract?.id, contract?.user?.id)}>
                                <div className="d-flex align-items-center cursor-pointer ">
                                    <h4 className="euro-symbol mb-0 text-nowrap">
                                        {priceSplitter(Math.round(contract?.price))}
                                    </h4>
                                    {(contract?.isRequested || contract?.isProposed) && (
                                        <p
                                            className={`mx-2 status ${
                                                contract?.isProposed ? proposalStatusClass : 'invite'
                                            } text-dark`}
                                        >
                                            {contract?.isProposed
                                                ? proposalStatusText
                                                : t('general.campaign_status.invite')}
                                        </p>
                                    )}
                                </div>
                                {!!contract?.additionalPrice && (
                                    <span className="text-muted font-10">
                                        <FaMoneyBillWave className="text-primary mr-1 font-14" />
                                        {t('brand.campaign.book.offer.additional_costs_included')}
                                    </span>
                                )}
                            </Col>
                            <Col className="justify-content-between d-flex ">
                                <div className="d-flex align-items-center">
                                    <p
                                        className="list-intro cursor-pointer px-1"
                                        onClick={() => openModal(contract?.id, contract?.user?.id)}
                                    >
                                        {clearHtmlFromString(contract?.description ?? '-')}
                                    </p>
                                </div>
                                <div className="d-flex flex-column align-items-end ">
                                    <Checkbox
                                        className={`${
                                            (isClient ||
                                                contract?.buttonType === 'Open' ||
                                                contract.buttonType === 'Resume') &&
                                            'd-none'
                                        } px-0 mb-lg-2`}
                                        checked={contract?.isSelected}
                                        onClick={() => selectContract(contract?.id, !contract.isSelected)}
                                    />
                                    <div className="d-flex align-items-center mt-lg-2">
                                        {!isClient && contract?.canCounter && (
                                            <Dropdown className="mx-2">
                                                <Dropdown.Toggle className="" variant="light" id="dropdown-basic">
                                                    <FaEllipsisV className="text-secondary" />
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                    <Dropdown.Item
                                                        onClick={() => openModal(contract?.id, contract?.user.id, true)}
                                                        className="d-flex align-items-center "
                                                    >
                                                        <i className="fi fi-rr-messages-question icon-fixed me-2"></i>
                                                        {t('brand.campaign.book.offer.negotiate')}
                                                    </Dropdown.Item>
                                                    <Dropdown.Item
                                                        onClick={() => opeDeclineModal(contract?.id, contract)}
                                                        className="d-flex align-items-center danger-hover"
                                                    >
                                                        <CrossModalIcon width={16} height={16} className="me-2" />
                                                        {t('brand.campaign.book.contract.deny_contract')}
                                                    </Dropdown.Item>
                                                    {/* {canSelectBestPick &&
                                                    pendingAndNegotiateStatus.includes(contract?.status) && (
                                                        <Dropdown.Item onClick={() => setBestPickAction(contract?.id)}>
                                                            {contract.isBestPick
                                                                ? t(
                                                                      'brand.campaign.book.offer.filters.remove_best_pick'
                                                                  )
                                                                : t('brand.campaign.book.offer.filters.set_best_pick')}
                                                        </Dropdown.Item>
                                                    )} */}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        )}
                                        {isClient &&
                                            contract?.isProposed &&
                                            !contract?.isApproved &&
                                            !contract?.isDeclined && (
                                                <Dropdown className="mx-2">
                                                    <Dropdown.Toggle className="" variant="light" id="dropdown-basic">
                                                        <FaEllipsisV className="text-secondary" />
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu>
                                                        <Dropdown.Item onClick={() => setApproveTarget(contract)}>
                                                            <div className="d-flex align-items-center">
                                                                <CheckModalIcon
                                                                    width={14}
                                                                    height={14}
                                                                    className="me-2"
                                                                />
                                                                {t('brand.campaign.book.offer.approve_proposal')}
                                                            </div>
                                                        </Dropdown.Item>
                                                        <Dropdown.Item
                                                            onClick={() =>
                                                                opeProposalDeclineModal(contract?.id, contract)
                                                            }
                                                        >
                                                            <div className="d-flex align-items-center">
                                                                <CrossModalIcon
                                                                    width={14}
                                                                    height={14}
                                                                    className="me-2"
                                                                />
                                                                {t('brand.campaign.book.offer.decline_proposal')}
                                                            </div>
                                                        </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            )}
                                        {!isClient && contract?.isProposed && !contract?.isApproved && (
                                            <Dropdown className="mx-2">
                                                <Dropdown.Toggle className="" variant="light" id="dropdown-basic">
                                                    <FaEllipsisV className="text-secondary" />
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                    <Dropdown.Item
                                                        onClick={() =>
                                                            openModal(contract?.id, contract?.user?.id, true)
                                                        }
                                                    >
                                                        <EditIcon
                                                            width={20}
                                                            height={20}
                                                            className="dropdown-menu-icon"
                                                        />
                                                        {t('brand.campaign.book.offer.edit_proposal')}
                                                    </Dropdown.Item>
                                                    {!contract?.isDeclined && (
                                                        <Dropdown.Item
                                                            className="text-danger"
                                                            onClick={() => openDeleteProposalModal(contract?.id)}
                                                        >
                                                            <DeleteIcon
                                                                width={20}
                                                                height={20}
                                                                className="dropdown-menu-icon"
                                                            />
                                                            {t('brand.campaign.book.offer.delete_proposal')}
                                                        </Dropdown.Item>
                                                    )}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        )}
                                        <Button
                                            className="position-relative"
                                            size="sm"
                                            onClick={
                                                isClient ||
                                                contract?.buttonType === 'Open' ||
                                                contract.buttonType === 'Resume'
                                                    ? () =>
                                                          openModal(
                                                              contract?.id,
                                                              contract?.user?.id,
                                                              contract.buttonType === 'Resume'
                                                          )
                                                    : () => openConfirmModal(contract?.id, contract)
                                            }
                                        >
                                            {t(`general.button.${isClient ? 'Open' : contract?.buttonType}`)}
                                            {contract?.hasUnreadComments && (
                                                <div
                                                    id="bullet"
                                                    className="red-dot position-absolute"
                                                    style={{ top: '-5px', right: '-5px' }}
                                                />
                                            )}
                                        </Button>
                                    </div>
                                </div>
                            </Col>
                        </div>
                    </Row>
                );
            })}
        </div>
    );
}
